// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file sync_update.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Achievement } from "./achievements_pb";
import { file_achievements } from "./achievements_pb";
import type { AuthenticatorType } from "./authenticator_type_pb";
import { file_authenticator_type } from "./authenticator_type_pb";
import type { CredentialType } from "./credential_type_pb";
import { file_credential_type } from "./credential_type_pb";
import type { LicenseType } from "./license_type_pb";
import { file_license_type } from "./license_type_pb";
import type { ProfileAuthenticatorLock, ProfileProfileLock } from "./locks_pb";
import { file_locks } from "./locks_pb";
import type { UnlockTimeLimit } from "./unlock_time_limit_pb";
import { file_unlock_time_limit } from "./unlock_time_limit_pb";
import type { MaintenanceTask } from "./maintenance_task_pb";
import { file_maintenance_task } from "./maintenance_task_pb";
import type { PrimaryLoginDevice } from "./primary_login_device_pb";
import { file_primary_login_device } from "./primary_login_device_pb";
import type { ProfileType } from "./profile_type_pb";
import { file_profile_type } from "./profile_type_pb";
import type { SessionType } from "./session_type_pb";
import { file_session_type } from "./session_type_pb";
import type { OrganizationType } from "./organization_type_pb";
import { file_organization_type } from "./organization_type_pb";
import type { VaultMemberSyncMode } from "./vault_member_sync_mode_pb";
import { file_vault_member_sync_mode } from "./vault_member_sync_mode_pb";
import type { VaultType } from "./vault_type_pb";
import { file_vault_type } from "./vault_type_pb";
import type { WebauthnPrfSupportStatus } from "./webauthn_prf_support_status_pb";
import { file_webauthn_prf_support_status } from "./webauthn_prf_support_status_pb";
import type { Role } from "./role_pb";
import { file_role } from "./role_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sync_update.proto.
 */
export const file_sync_update: GenFile = /*@__PURE__*/
  fileDesc("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", [file_achievements, file_authenticator_type, file_credential_type, file_license_type, file_locks, file_unlock_time_limit, file_maintenance_task, file_primary_login_device, file_profile_type, file_session_type, file_organization_type, file_vault_member_sync_mode, file_vault_type, file_webauthn_prf_support_status, file_role, file_google_protobuf_timestamp]);

/**
 * @generated from message domain.SyncUpdateProfile
 */
export type SyncUpdateProfile = Message<"domain.SyncUpdateProfile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.ProfileType profile_type = 2;
   */
  profileType: ProfileType;

  /**
   * @generated from field: string key_generation_id = 3;
   */
  keyGenerationId: string;

  /**
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;

  /**
   * cryptographic identity (can be regenerated)
   *
   * @generated from field: bytes high_security_identity_sig_pub_key = 5;
   */
  highSecurityIdentitySigPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_vault_key_enc_pub_key = 6;
   */
  highSecurityVaultKeyEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_vault_key_enc_pub_key_signature = 7;
   */
  highSecurityVaultKeyEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key = 8;
   */
  highSecurityProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key_signature = 9;
   */
  highSecurityProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key = 10;
   */
  storableSigPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key_signature = 11;
   */
  storableSigPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_vault_key_enc_pub_key = 12;
   */
  storableVaultKeyEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_vault_key_enc_pub_key_signature = 13;
   */
  storableVaultKeyEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key = 14;
   */
  storableProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key_signature = 15;
   */
  storableProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * list of locks (one per authenticator, or one profile)
   *
   * @generated from field: repeated domain.ProfileAuthenticatorLock authenticator_locks = 16;
   */
  authenticatorLocks: ProfileAuthenticatorLock[];

  /**
   * @generated from field: domain.ProfileProfileLock profile_lock = 19;
   */
  profileLock?: ProfileProfileLock | undefined;

  /**
   * public metadata, can be changed
   *
   * @generated from field: string email = 17;
   */
  email: string;

  /**
   * @generated from field: string unverified_email = 18;
   */
  unverifiedEmail: string;
};

/**
 * Describes the message domain.SyncUpdateProfile.
 * Use `create(SyncUpdateProfileSchema)` to create a new message.
 */
export const SyncUpdateProfileSchema: GenMessage<SyncUpdateProfile> = /*@__PURE__*/
  messageDesc(file_sync_update, 0);

/**
 * The SyncResponse contains information used by client-core to bring itself up
 * to date with backend state. It can be obtained via polling (Sync), or
 * streaming (StreamingSync).
 *
 * The SyncResponse contains four components: sessions, vaults, open login
 * channels, and the session unlock state of the specific session that made the
 * request.
 *
 * @generated from message domain.SyncUpdate
 */
export type SyncUpdate = Message<"domain.SyncUpdate"> & {
  /**
   * management fields
   *
   * @generated from field: google.protobuf.Timestamp server_time = 7;
   */
  serverTime?: Timestamp | undefined;

  /**
   * @generated from field: int64 sync_version = 15;
   */
  syncVersion: bigint;

  /**
   * @generated from field: bool token_refresh_needed = 21;
   */
  tokenRefreshNeeded: boolean;

  /**
   * @generated from field: bool client_outdated = 22;
   */
  clientOutdated: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp leaked_passwords_change_time = 23;
   */
  leakedPasswordsChangeTime?: Timestamp | undefined;

  /**
   * list of populated optional fields, see below.
   *
   * @generated from field: repeated domain.SyncUpdateField updated_fields = 11;
   */
  updatedFields: SyncUpdateField[];

  /**
   * mandatory fields
   * this one might be required during any sync, so we send it every time
   *
   * @generated from field: domain.SyncUpdate.SessionUnlock session_unlock = 4;
   */
  sessionUnlock?: SyncUpdate_SessionUnlock | undefined;

  /**
   * optional fields. will be populated (possibly empty) if they occur in updated_fields.
   *
   * @generated from field: domain.SyncUpdate.User user = 8;
   */
  user?: SyncUpdate_User | undefined;

  /**
   * @generated from field: repeated domain.SyncUpdate.Session sessions = 1;
   */
  sessions: SyncUpdate_Session[];

  /**
   * @generated from field: repeated domain.SyncUpdate.Vault vaults = 2;
   */
  vaults: SyncUpdate_Vault[];

  /**
   * @generated from field: repeated domain.Achievement achievements = 6;
   */
  achievements: Achievement[];

  /**
   * @generated from field: repeated domain.SyncUpdate.Channel channels = 3;
   */
  channels: SyncUpdate_Channel[];

  /**
   * @generated from field: repeated domain.SyncUpdate.Organization organizations = 13;
   */
  organizations: SyncUpdate_Organization[];

  /**
   * @generated from field: repeated domain.SyncUpdate.RelatedProfile related_profiles = 18;
   */
  relatedProfiles: SyncUpdate_RelatedProfile[];

  /**
   * @generated from field: repeated domain.SyncUpdateProfile profiles = 17;
   */
  profiles: SyncUpdateProfile[];

  /**
   * @generated from field: domain.SyncUpdate.MaintenanceSettings maintenance_settings = 19;
   */
  maintenanceSettings?: SyncUpdate_MaintenanceSettings | undefined;

  /**
   * @generated from field: repeated domain.SyncUpdate.PreliminaryProfile preliminary_profiles = 20;
   */
  preliminaryProfiles: SyncUpdate_PreliminaryProfile[];
};

/**
 * Describes the message domain.SyncUpdate.
 * Use `create(SyncUpdateSchema)` to create a new message.
 */
export const SyncUpdateSchema: GenMessage<SyncUpdate> = /*@__PURE__*/
  messageDesc(file_sync_update, 1);

/**
 * @generated from message domain.SyncUpdate.Session
 */
export type SyncUpdate_Session = Message<"domain.SyncUpdate.Session"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_used_at = 3;
   */
  lastUsedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp unlocked_at = 4;
   */
  unlockedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp unlocked_until = 5;
   */
  unlockedUntil?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp unlock_requested_at = 6;
   */
  unlockRequestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp unlock_extend_at = 12;
   */
  unlockExtendAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: domain.SessionType session_type = 9;
   */
  sessionType: SessionType;

  /**
   * configurable variables via SessionService.Update
   *
   * @generated from field: string client_settings = 8;
   */
  clientSettings: string;

  /**
   * if this is empty, all profiles are enabled for this session
   * there may be ids in this list that no longer exist
   *
   * @generated from field: repeated string enabled_profile_ids = 10;
   */
  enabledProfileIds: string[];

  /**
   * Deprecated, clients from 2026-05-27 or newer use unlock_time_limit_minutes
   *
   * @generated from field: domain.UnlockTimeLimit unlock_time_limit = 11 [deprecated = true];
   * @deprecated
   */
  unlockTimeLimit?: UnlockTimeLimit | undefined;

  /**
   * @generated from field: uint32 unlock_time_limit_minutes = 13;
   */
  unlockTimeLimitMinutes: number;
};

/**
 * Describes the message domain.SyncUpdate.Session.
 * Use `create(SyncUpdate_SessionSchema)` to create a new message.
 */
export const SyncUpdate_SessionSchema: GenMessage<SyncUpdate_Session> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 0);

/**
 * @generated from message domain.SyncUpdate.Vault
 */
export type SyncUpdate_Vault = Message<"domain.SyncUpdate.Vault"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string commit_id = 2;
   */
  commitId: string;

  /**
   * @generated from field: string generation_id = 3;
   */
  generationId: string;

  /**
   * @generated from field: string associated_vault_id = 6;
   */
  associatedVaultId: string;

  /**
   * @generated from field: string organization_id = 8;
   */
  organizationId: string;

  /**
   * @generated from field: repeated domain.SyncUpdate.Vault.Profile profiles = 11;
   */
  profiles: SyncUpdate_Vault_Profile[];

  /**
   * @generated from field: domain.VaultType vault_type = 5;
   */
  vaultType: VaultType;

  /**
   * @generated from field: bool dirty = 19;
   */
  dirty: boolean;

  /**
   * @generated from field: string profile_key_generation_id = 12;
   */
  profileKeyGenerationId: string;

  /**
   * @generated from field: string admin_profile_key_generation_id = 18;
   */
  adminProfileKeyGenerationId: string;

  /**
   * nil if vault has no message queue
   *
   * @generated from field: bytes message_public_key = 15;
   */
  messagePublicKey: Uint8Array;

  /**
   * @generated from field: bool has_messages_queued = 16;
   */
  hasMessagesQueued: boolean;

  /**
   * slug is set for VAULT_TYPE_INBOX vaults only
   *
   * @generated from field: string inbox_slug = 17;
   */
  inboxSlug: string;

  /**
   * @generated from field: bool inbox_enabled = 20;
   */
  inboxEnabled: boolean;

  /**
   * @generated from field: domain.VaultMemberSyncMode member_sync_mode = 21;
   */
  memberSyncMode: VaultMemberSyncMode;

  /**
   * @generated from field: string entra_group_id = 22;
   */
  entraGroupId: string;

  /**
   * @generated from field: repeated domain.MaintenanceTask required_maintenance_tasks = 23;
   */
  requiredMaintenanceTasks: MaintenanceTask[];

  /**
   * @generated from field: bool regenerate_on_sync = 24;
   */
  regenerateOnSync: boolean;
};

/**
 * Describes the message domain.SyncUpdate.Vault.
 * Use `create(SyncUpdate_VaultSchema)` to create a new message.
 */
export const SyncUpdate_VaultSchema: GenMessage<SyncUpdate_Vault> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 1);

/**
 * @generated from message domain.SyncUpdate.Vault.Profile
 */
export type SyncUpdate_Vault_Profile = Message<"domain.SyncUpdate.Vault.Profile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message domain.SyncUpdate.Vault.Profile.
 * Use `create(SyncUpdate_Vault_ProfileSchema)` to create a new message.
 */
export const SyncUpdate_Vault_ProfileSchema: GenMessage<SyncUpdate_Vault_Profile> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 1, 0);

/**
 * @generated from message domain.SyncUpdate.Channel
 */
export type SyncUpdate_Channel = Message<"domain.SyncUpdate.Channel"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string channel_type = 2;
   */
  channelType: string;
};

/**
 * Describes the message domain.SyncUpdate.Channel.
 * Use `create(SyncUpdate_ChannelSchema)` to create a new message.
 */
export const SyncUpdate_ChannelSchema: GenMessage<SyncUpdate_Channel> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 2);

/**
 * @generated from message domain.SyncUpdate.SessionUnlock
 */
export type SyncUpdate_SessionUnlock = Message<"domain.SyncUpdate.SessionUnlock"> & {
  /**
   * @generated from field: bytes encrypted_secret = 1;
   */
  encryptedSecret: Uint8Array;

  /**
   * @generated from field: string authenticator_id = 2;
   */
  authenticatorId: string;
};

/**
 * Describes the message domain.SyncUpdate.SessionUnlock.
 * Use `create(SyncUpdate_SessionUnlockSchema)` to create a new message.
 */
export const SyncUpdate_SessionUnlockSchema: GenMessage<SyncUpdate_SessionUnlock> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 3);

/**
 * @generated from message domain.SyncUpdate.Authenticator
 */
export type SyncUpdate_Authenticator = Message<"domain.SyncUpdate.Authenticator"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.AuthenticatorType authenticator_type = 13;
   */
  authenticatorType: AuthenticatorType;

  /**
   * @generated from field: bytes high_security_login_sig_pub_key = 3;
   */
  highSecurityLoginSigPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_identity_sig_pub_key = 4;
   */
  highSecurityIdentitySigPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key = 5;
   */
  highSecurityProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key_signature = 6;
   */
  highSecurityProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key = 7;
   */
  storableSigPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key_signature = 8;
   */
  storableSigPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key = 9;
   */
  storableProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key_signature = 10;
   */
  storableProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: string secret_info = 11;
   */
  secretInfo: string;

  /**
   * @generated from field: bytes secret_salt = 12;
   */
  secretSalt: Uint8Array;
};

/**
 * Describes the message domain.SyncUpdate.Authenticator.
 * Use `create(SyncUpdate_AuthenticatorSchema)` to create a new message.
 */
export const SyncUpdate_AuthenticatorSchema: GenMessage<SyncUpdate_Authenticator> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 4);

/**
 * @generated from message domain.SyncUpdate.User
 */
export type SyncUpdate_User = Message<"domain.SyncUpdate.User"> & {
  /**
   * @generated from field: string server_side_settings = 3;
   */
  serverSideSettings: string;

  /**
   * @generated from field: bytes authenticator_block_hash = 4;
   */
  authenticatorBlockHash: Uint8Array;

  /**
   * @generated from field: string preferred_locale = 6;
   */
  preferredLocale: string;

  /**
   * @generated from field: string preliminary_email = 8;
   */
  preliminaryEmail: string;

  /**
   * @generated from field: repeated domain.SyncUpdate.User.WebauthnCredential webauthn_credentials = 9;
   */
  webauthnCredentials: SyncUpdate_User_WebauthnCredential[];

  /**
   * @generated from field: string user_client_settings = 10;
   */
  userClientSettings: string;

  /**
   * @generated from field: repeated string open_user_confirmation_ids = 11;
   */
  openUserConfirmationIds: string[];

  /**
   * @generated from field: bool profiles_locked = 12;
   */
  profilesLocked: boolean;
};

/**
 * Describes the message domain.SyncUpdate.User.
 * Use `create(SyncUpdate_UserSchema)` to create a new message.
 */
export const SyncUpdate_UserSchema: GenMessage<SyncUpdate_User> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 5);

/**
 * @generated from message domain.SyncUpdate.User.WebauthnCredential
 */
export type SyncUpdate_User_WebauthnCredential = Message<"domain.SyncUpdate.User.WebauthnCredential"> & {
  /**
   * @generated from field: string webauthn_id = 7;
   */
  webauthnId: string;

  /**
   * @generated from field: string aaguid = 2;
   */
  aaguid: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_used_at = 4;
   */
  lastUsedAt?: Timestamp | undefined;

  /**
   * @generated from field: domain.CredentialType credential_type = 5;
   */
  credentialType: CredentialType;

  /**
   * @generated from field: string session_id = 6;
   */
  sessionId: string;

  /**
   * @generated from field: domain.WebauthnPrfSupportStatus prf_support_status = 8;
   */
  prfSupportStatus: WebauthnPrfSupportStatus;
};

/**
 * Describes the message domain.SyncUpdate.User.WebauthnCredential.
 * Use `create(SyncUpdate_User_WebauthnCredentialSchema)` to create a new message.
 */
export const SyncUpdate_User_WebauthnCredentialSchema: GenMessage<SyncUpdate_User_WebauthnCredential> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 5, 0);

/**
 * @generated from message domain.SyncUpdate.Organization
 */
export type SyncUpdate_Organization = Message<"domain.SyncUpdate.Organization"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.OrganizationType organization_type = 20;
   */
  organizationType: OrganizationType;

  /**
   * @generated from field: repeated domain.SyncUpdate.OrganizationProfile profiles = 10;
   */
  profiles: SyncUpdate_OrganizationProfile[];

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string icon = 4;
   */
  icon: string;

  /**
   * @generated from field: bool restrict_personal_logins = 19;
   */
  restrictPersonalLogins: boolean;

  /**
   * @generated from field: bool auditlog_enable = 14;
   */
  auditlogEnable: boolean;

  /**
   * @generated from field: bool role_management_enable = 35;
   */
  roleManagementEnable: boolean;

  /**
   * @generated from field: bool child_organization_management_enable = 21;
   */
  childOrganizationManagementEnable: boolean;

  /**
   * @generated from field: bool service_user_enable = 29;
   */
  serviceUserEnable: boolean;

  /**
   * @generated from field: bool monitoring_enable = 36;
   */
  monitoringEnable: boolean;

  /**
   * @generated from field: string password_policy = 23;
   */
  passwordPolicy: string;

  /**
   * @generated from field: domain.UnlockTimeLimit unlock_time_limit = 26;
   */
  unlockTimeLimit?: UnlockTimeLimit | undefined;

  /**
   * @generated from field: bool is_preliminary = 13;
   */
  isPreliminary: boolean;

  /**
   * @generated from field: bool is_delegated_admin = 24;
   */
  isDelegatedAdmin: boolean;

  /**
   * @generated from field: bool profile_child_organization_management_show = 32;
   */
  profileChildOrganizationManagementShow: boolean;

  /**
   * @generated from field: repeated string role_ids = 33;
   */
  roleIds: string[];

  /**
   * @generated from field: string super_user_id = 7;
   */
  superUserId: string;

  /**
   * @generated from field: string admin_profile_id = 16;
   */
  adminProfileId: string;

  /**
   * only set if the user is org admin
   *
   * @generated from field: domain.SyncUpdate.Organization.AdminInfo admin_info = 15;
   */
  adminInfo?: SyncUpdate_Organization_AdminInfo | undefined;

  /**
   * @generated from field: domain.SubscriptionError subscription_error = 11;
   */
  subscriptionError: SubscriptionError;

  /**
   * @generated from field: string verified_domain = 17;
   */
  verifiedDomain: string;

  /**
   * @generated from field: string client_settings = 25;
   */
  clientSettings: string;

  /**
   * @generated from field: domain.SyncUpdate.Organization.ParentOrganizationInfo parent_organization_info = 27;
   */
  parentOrganizationInfo?: SyncUpdate_Organization_ParentOrganizationInfo | undefined;

  /**
   * @generated from field: repeated domain.MaintenanceTask required_maintenance_tasks = 28;
   */
  requiredMaintenanceTasks: MaintenanceTask[];

  /**
   * @generated from field: string entra_user_id = 30;
   */
  entraUserId: string;

  /**
   * @generated from field: domain.SyncUpdate.Organization.LoginSummaryVaultInfo login_summary_vault_info = 31;
   */
  loginSummaryVaultInfo?: SyncUpdate_Organization_LoginSummaryVaultInfo | undefined;

  /**
   * @generated from field: repeated domain.Role roles = 34;
   */
  roles: Role[];
};

/**
 * Describes the message domain.SyncUpdate.Organization.
 * Use `create(SyncUpdate_OrganizationSchema)` to create a new message.
 */
export const SyncUpdate_OrganizationSchema: GenMessage<SyncUpdate_Organization> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 6);

/**
 * @generated from message domain.SyncUpdate.Organization.AdminInfo
 */
export type SyncUpdate_Organization_AdminInfo = Message<"domain.SyncUpdate.Organization.AdminInfo"> & {
  /**
   * @generated from field: domain.SyncUpdateProfile admin_profile = 9;
   */
  adminProfile?: SyncUpdateProfile | undefined;

  /**
   * @generated from field: string entra_tenant_id = 6;
   */
  entraTenantId: string;

  /**
   * @generated from field: bool entra_prefer_user_principal_name = 13;
   */
  entraPreferUserPrincipalName: boolean;

  /**
   * @generated from field: string entra_settings = 28;
   */
  entraSettings: string;

  /**
   * @generated from field: google.protobuf.Timestamp entra_synchronized_at = 14;
   */
  entraSynchronizedAt?: Timestamp | undefined;

  /**
   * @generated from field: bool csv_integration_active = 7;
   */
  csvIntegrationActive: boolean;

  /**
   * @generated from field: bool google_workspace_integration_active = 8;
   */
  googleWorkspaceIntegrationActive: boolean;

  /**
   * empty if not in trial mode
   *
   * @generated from field: google.protobuf.Timestamp trial_end_date = 10;
   */
  trialEndDate?: Timestamp | undefined;

  /**
   * @generated from field: domain.LicenseType license_type = 11;
   */
  licenseType: LicenseType;

  /**
   * @generated from field: string parent_organization_admin_profile_id = 12;
   */
  parentOrganizationAdminProfileId: string;

  /**
   * @generated from field: string billing_organization_id = 15;
   */
  billingOrganizationId: string;
};

/**
 * Describes the message domain.SyncUpdate.Organization.AdminInfo.
 * Use `create(SyncUpdate_Organization_AdminInfoSchema)` to create a new message.
 */
export const SyncUpdate_Organization_AdminInfoSchema: GenMessage<SyncUpdate_Organization_AdminInfo> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 6, 0);

/**
 * @generated from message domain.SyncUpdate.Organization.ParentOrganizationInfo
 */
export type SyncUpdate_Organization_ParentOrganizationInfo = Message<"domain.SyncUpdate.Organization.ParentOrganizationInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string icon = 3;
   */
  icon: string;

  /**
   * @generated from field: string metadata = 4;
   */
  metadata: string;
};

/**
 * Describes the message domain.SyncUpdate.Organization.ParentOrganizationInfo.
 * Use `create(SyncUpdate_Organization_ParentOrganizationInfoSchema)` to create a new message.
 */
export const SyncUpdate_Organization_ParentOrganizationInfoSchema: GenMessage<SyncUpdate_Organization_ParentOrganizationInfo> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 6, 1);

/**
 * @generated from message domain.SyncUpdate.Organization.LoginSummaryVaultInfo
 */
export type SyncUpdate_Organization_LoginSummaryVaultInfo = Message<"domain.SyncUpdate.Organization.LoginSummaryVaultInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * @generated from field: bytes message_public_key = 3;
   */
  messagePublicKey: Uint8Array;
};

/**
 * Describes the message domain.SyncUpdate.Organization.LoginSummaryVaultInfo.
 * Use `create(SyncUpdate_Organization_LoginSummaryVaultInfoSchema)` to create a new message.
 */
export const SyncUpdate_Organization_LoginSummaryVaultInfoSchema: GenMessage<SyncUpdate_Organization_LoginSummaryVaultInfo> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 6, 2);

/**
 * @generated from message domain.SyncUpdate.OrganizationProfile
 */
export type SyncUpdate_OrganizationProfile = Message<"domain.SyncUpdate.OrganizationProfile"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: bool is_not_connected = 4;
   */
  isNotConnected: boolean;

  /**
   * @generated from field: bool is_delegated_admin = 14;
   */
  isDelegatedAdmin: boolean;

  /**
   * @generated from field: bool is_service = 15;
   */
  isService: boolean;

  /**
   * @generated from field: bool child_organization_management_show = 17;
   */
  childOrganizationManagementShow: boolean;

  /**
   * @generated from field: repeated string role_ids = 18;
   */
  roleIds: string[];

  /**
   * @generated from field: string personal_vault_id = 8;
   */
  personalVaultId: string;

  /**
   * only filled for roles with can_view_users
   *
   * @generated from field: string preliminary_user_id = 5;
   */
  preliminaryUserId: string;

  /**
   * only filled for roles with can_view_users
   *
   * @generated from field: string start_code = 9;
   */
  startCode: string;

  /**
   * only filled for roles with can_view_users
   *
   * @generated from field: google.protobuf.Timestamp start_code_generated_at = 10;
   */
  startCodeGeneratedAt?: Timestamp | undefined;

  /**
   * only filled for roles with can_view_users
   *
   * @generated from field: google.protobuf.Timestamp start_code_email_sent_at = 11;
   */
  startCodeEmailSentAt?: Timestamp | undefined;

  /**
   * only filled for roles with can_view_users
   *
   * @generated from field: domain.PrimaryLoginDevice primary_login_device = 12;
   */
  primaryLoginDevice: PrimaryLoginDevice;

  /**
   * only filled for roles with can_view_users
   *
   * @generated from field: google.protobuf.Timestamp last_active_at = 13;
   */
  lastActiveAt?: Timestamp | undefined;

  /**
   * only filled for roles with can_view_users
   *
   * @generated from field: string entra_user_id = 16;
   */
  entraUserId: string;

  /**
   * only filled for roles with can_view_users
   *
   * @generated from field: google.protobuf.Timestamp start_code_expired_at = 19;
   */
  startCodeExpiredAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.SyncUpdate.OrganizationProfile.
 * Use `create(SyncUpdate_OrganizationProfileSchema)` to create a new message.
 */
export const SyncUpdate_OrganizationProfileSchema: GenMessage<SyncUpdate_OrganizationProfile> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 7);

/**
 * @generated from message domain.SyncUpdate.RelatedProfile
 */
export type SyncUpdate_RelatedProfile = Message<"domain.SyncUpdate.RelatedProfile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message domain.SyncUpdate.RelatedProfile.
 * Use `create(SyncUpdate_RelatedProfileSchema)` to create a new message.
 */
export const SyncUpdate_RelatedProfileSchema: GenMessage<SyncUpdate_RelatedProfile> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 8);

/**
 * @generated from message domain.SyncUpdate.PreliminaryProfile
 */
export type SyncUpdate_PreliminaryProfile = Message<"domain.SyncUpdate.PreliminaryProfile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;
};

/**
 * Describes the message domain.SyncUpdate.PreliminaryProfile.
 * Use `create(SyncUpdate_PreliminaryProfileSchema)` to create a new message.
 */
export const SyncUpdate_PreliminaryProfileSchema: GenMessage<SyncUpdate_PreliminaryProfile> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 9);

/**
 * @generated from message domain.SyncUpdate.MaintenanceSettings
 */
export type SyncUpdate_MaintenanceSettings = Message<"domain.SyncUpdate.MaintenanceSettings"> & {
  /**
   * @generated from field: repeated domain.MaintenanceTask allowed_tasks = 1;
   */
  allowedTasks: MaintenanceTask[];
};

/**
 * Describes the message domain.SyncUpdate.MaintenanceSettings.
 * Use `create(SyncUpdate_MaintenanceSettingsSchema)` to create a new message.
 */
export const SyncUpdate_MaintenanceSettingsSchema: GenMessage<SyncUpdate_MaintenanceSettings> = /*@__PURE__*/
  messageDesc(file_sync_update, 1, 10);

/**
 * @generated from enum domain.SyncUpdateField
 */
export enum SyncUpdateField {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: SU_UNKNOWN = 0;
   */
  SU_UNKNOWN = 0,

  /**
   * @generated from enum value: SU_USER = 1;
   */
  SU_USER = 1,

  /**
   * @generated from enum value: SU_SESSIONS = 2;
   */
  SU_SESSIONS = 2,

  /**
   * @generated from enum value: SU_VAULTS = 3;
   */
  SU_VAULTS = 3,

  /**
   * @generated from enum value: SU_ACHIEVEMENTS = 4;
   */
  SU_ACHIEVEMENTS = 4,

  /**
   * @generated from enum value: SU_CHANNELS = 5;
   */
  SU_CHANNELS = 5,

  /**
   * @generated from enum value: SU_ORGANIZATIONS = 6;
   */
  SU_ORGANIZATIONS = 6,

  /**
   * @generated from enum value: SU_RELATED_PROFILES = 7;
   */
  SU_RELATED_PROFILES = 7,

  /**
   * also includes preliminary profiles
   *
   * @generated from enum value: SU_PROFILES = 8;
   */
  SU_PROFILES = 8,

  /**
   * @generated from enum value: SU_MAINTENANCE_SETTINGS = 9;
   */
  SU_MAINTENANCE_SETTINGS = 9,
}

/**
 * Describes the enum domain.SyncUpdateField.
 */
export const SyncUpdateFieldSchema: GenEnum<SyncUpdateField> = /*@__PURE__*/
  enumDesc(file_sync_update, 0);

/**
 * @generated from enum domain.SubscriptionError
 */
export enum SubscriptionError {
  /**
   * @generated from enum value: SUBSCRIPTION_ERROR_OK = 0;
   */
  OK = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_ERROR_TRIAL_EXCEEDED = 1;
   */
  TRIAL_EXCEEDED = 1,

  /**
   * @generated from enum value: SUBSCRIPTION_ERROR_PADDLE_PAUSED = 2;
   */
  PADDLE_PAUSED = 2,

  /**
   * @generated from enum value: SUBSCRIPTION_ERROR_DELINQUENT = 3;
   */
  DELINQUENT = 3,
}

/**
 * Describes the enum domain.SubscriptionError.
 */
export const SubscriptionErrorSchema: GenEnum<SubscriptionError> = /*@__PURE__*/
  enumDesc(file_sync_update, 1);

